const $ = jQuery.noConflict();

'use strict';
const InfoList = {
	init: function() {
		if (window.innerWidth < 992) {
			const firstAccordionItem = $('.js-acc-item-address').first();
			firstAccordionItem.addClass('active');

			const firstContentItem = firstAccordionItem.find('.js-content-address');
			if (firstContentItem.length > 0) {
				firstContentItem.addClass('active').css('max-height', firstContentItem[0].scrollHeight + 'px');
			}
			$('.js-title-btn').on('click', function() {
				const parentItem = $(this).closest('.js-acc-item-address');
				const isActive = parentItem.hasClass('active');

				$('.js-acc-item-address').removeClass('active');
				$('.js-content-address').removeClass('active').css('max-height', '0');

				if (!isActive) {
					parentItem.addClass('active');
					const nextContentItem = $(this).next('.js-content-address');
					if (nextContentItem.length > 0) {
						nextContentItem.addClass('active').css('max-height', nextContentItem[0].scrollHeight + 'px');
					}
				}
			});
		}
	},
};

export default InfoList;
